"use client";

import { useEffect } from "react";

/**
 * ServiceWorkerRegistration Component
 * Registers a service worker to cache JavaScript chunks
 * This helps prevent chunk load errors on mobile devices
 */
export default function ServiceWorkerRegistration() {
  useEffect(() => {
    // Only register service worker in production and if supported
    if (
      typeof window === "undefined" ||
      !("serviceWorker" in navigator) ||
      process.env.NODE_ENV !== "production"
    ) {
      console.log("[SW] Service worker not supported or not in production");
      return;
    }

    // Register the service worker
    const registerServiceWorker = async () => {
      try {
        console.log("[SW] Registering service worker...");

        const registration = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
        });

        console.log(
          "[SW] Service worker registered successfully:",
          registration.scope
        );

        // Handle updates
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;

          if (newWorker) {
            console.log("[SW] New service worker found, installing...");

            newWorker.addEventListener("statechange", () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                console.log("[SW] New service worker installed, update available");

                // Optionally notify user about update
                // You could show a toast here to prompt user to refresh

                // Auto-activate new service worker after a delay
                setTimeout(() => {
                  newWorker.postMessage({ type: "SKIP_WAITING" });
                }, 1000);
              }
            });
          }
        });

        // Handle controller change (new service worker activated)
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          console.log("[SW] New service worker activated");
          // Optionally reload the page
          // window.location.reload();
        });

        // Check for updates periodically (every 1 hour)
        setInterval(
          () => {
            registration.update();
          },
          60 * 60 * 1000
        );

        // Log cache size for debugging
        if (registration.active) {
          const channel = new MessageChannel();

          channel.port1.onmessage = (event) => {
            if (event.data.type === "CACHE_SIZE") {
              console.log(
                `[SW] Cached ${event.data.size} chunk(s) for offline use`
              );
            }
          };

          registration.active.postMessage(
            { type: "GET_CACHE_SIZE" },
            [channel.port2]
          );
        }
      } catch (error) {
        console.error("[SW] Service worker registration failed:", error);
      }
    };

    // Register on load
    if (document.readyState === "complete") {
      registerServiceWorker();
    } else {
      window.addEventListener("load", registerServiceWorker);
      return () => window.removeEventListener("load", registerServiceWorker);
    }
  }, []);

  // This component doesn't render anything
  return null;
}

